// extracted by mini-css-extract-plugin
module.exports = {"productCardContainer":"AddProductForm_productCardContainer__btSzB","input":"AddProductForm_input__3Vg1H","buttons":"AddProductForm_buttons__3wPIh"};